export default __webpack_public_path__ + "static/well_with_diabetes_logo-1733bd645468ddf4f1548d8a5736fd40.svg";